import React from 'react';
import { selectCurrentDepth } from '@/redux/selectors/fileManagerSelectors';
import FileSourcesColumn from './FileSourcesColumn';
import FileNavigationColumn from './FileNavigationColumn';
import { useAppSelector } from '@/redux/hooks';

const FileNavigationContainer: React.FC = () => {
  const currentDepth = useAppSelector(selectCurrentDepth);
  const columns: JSX.Element[] = [];

  for (let i = 0; i < currentDepth; i++) {
    columns.push(<FileNavigationColumn key={i} depth={i} />);
  }

  return (
    <>
      <FileSourcesColumn key="base" />
      {columns}
    </>
  );
};

export default FileNavigationContainer;
